
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veranstaltungen",
      function () {
        return require("private-next-pages/veranstaltungen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veranstaltungen"])
      });
    }
  